module.exports = __webpack_public_path__ + "static/img/新闻资讯.1b3aacd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/新闻资讯.jpg
// module id = Yj6n
// module chunks = 1